
import { app } from '..';
import { storageManager } from './StorageManager';
import { utils } from 'pixi.js';

export class PerformanceManager {
    constructor() {

        this.fps = [];
        this.timer = 0;

        this.performanceLevel = storageManager.getPerfLevel();
        this.setPerformanceLevel(this.performanceLevel);

        this.smallChunks = utils.isMobile.amazon.device || utils.isMobile.apple.device;
        this.dontUseBitmaps = utils.isMobile.amazon.device;
    }

    setPerformanceLevel(level){
        switch(level){
            case 0:
                this.setDpr(0.6);
                break;
            case 1:
                this.setDpr(0.75);
                break;
            case 2:
                this.setDpr(1);
                break;
            case 3:
                this.setDpr(2);
                break;
        }
        this.performanceLevel = level;
        storageManager.setPerfLevel(level);
    }

    setDpr(ratio){
        if (ratio > window.devicePixelRatio){
            ratio = window.devicePixelRatio;
        }
        else {
            app.resizer.maxPixelRatio = ratio;
            app.resizer.setStyle();
        }
    }

    update(dt){
        if (this.fps.length >= 100){
            this.fps.shift();
        }
        this.fps.unshift(dt);

        this.timer += dt;
        if (this.timer > 5000){
            this.checkPerformance();
            this.timer = 0;
        }
    }

    getAverageFps(){
        let total = 0;

        for (let i = 0; i < this.fps.length; i++){
            total += this.fps[i];
        }

        return total / this.fps.length;
    }

    checkPerformance(){
        let averageFps = this.getAverageFps();

        if (averageFps < 30 && this.performanceLevel > 0){
            this.setPerformanceLevel(this.performanceLevel - 1);
        }
        if (averageFps > 55 && this.performanceLevel < 3){
            this.setPerformanceLevel(this.performanceLevel + 1);
        }
    }
}
